module.exports = __webpack_public_path__ + "media/src/admin/images/sort_desc_disabled-9fd6ae98032a359f1e61e6b9d6bde1e8.png";